export const SET_METRICS = 'SET_METRICS'
export const SET_METRIC = 'SET_METRIC'
export const RESET_METRIC = 'RESET_METRIC'
export const RESET_METRICS = 'RESET_METRICS'
